"use client";

import BannerContentSlider from "./BannerContentSlider";

const BannerSection = () => {
  return (
    <div className="h-239 lg:h-187.5 -mt-16 lg:-mt-23 relative z-10 overflow-hidden bg-[#383838]">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="size-full object-fill lg:object-cover absolute top-0 left-0 lg:object-center object-[65%] z-10  lg:mt-0"
      >
        <source 
          src="https://www.baghaffiliates.xyz/videos/bagh-bg.mp4"
          type="video/mp4" 
        />
      </video>
      {/* <img
        alt="asd"
        className="size-full object-cover absolute top-0 left-0 lg:object-center object-[65%] z-10 block lg:hidden"
        src="/videos/xmasbanner-mobile.gif"
      ></img> */}

      <BannerContentSlider />
    </div>
  );
};

export default BannerSection;
